import { motion } from 'framer-motion';
import { CheckCircle, Users, Wrench, Award } from 'lucide-react';

const WHATSAPP_NUMBER = "5521980277322";

const highlights = [
  "Técnicos altamente qualificados e certificados",
  "Diagnóstico preciso com tecnologia de ponta",
  "Peças originais e de alta qualidade",
  "Garantia em todos os serviços realizados",
  "Atendimento transparente e honesto",
  "Localização privilegiada na Barra da Tijuca",
];

const stats = [
  { icon: Users, value: "5000+", label: "Clientes Atendidos" },
  { icon: Wrench, value: "10+", label: "Anos de Experiência" },
  { icon: Award, value: "98%", label: "Satisfação" },
];

export const About = () => {
  return (
    <section id="sobre" className="section-dark py-24 md:py-32" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image/Visual Side */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="relative">
              {/* Main Image */}
              <div className="relative overflow-hidden border border-[#00F0FF]/20">
                <img
                  src="https://images.unsplash.com/photo-1726739819428-a8f250e60691?crop=entropy&cs=srgb&fm=jpg&q=85&w=800"
                  alt="Ferramentas técnicas profissionais"
                  className="w-full h-[400px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent"></div>
              </div>

              {/* Stats Overlay */}
              <div className="absolute -bottom-8 left-8 right-8 grid grid-cols-3 gap-4">
                {stats.map((stat, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2 + index * 0.1 }}
                    className="glass p-4 text-center"
                  >
                    <stat.icon className="w-6 h-6 text-[#00F0FF] mx-auto mb-2" />
                    <div className="font-orbitron text-xl font-bold text-white">{stat.value}</div>
                    <div className="text-xs text-[#94A3B8]">{stat.label}</div>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Text Content */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <span className="text-[#00F0FF] text-sm font-mono uppercase tracking-widest">
              [ Sobre Nós ]
            </span>
            <h2 className="font-orbitron text-3xl md:text-4xl font-bold text-white mt-4 mb-6">
              Sua Parceira em <span className="text-[#00F0FF]">Tecnologia</span>
            </h2>

            <div className="space-y-4 text-[#94A3B8] font-space leading-relaxed mb-8">
              <p>
                Somos sua parceira especializada em assistência técnica e suporte para smartphones, 
                tablets, smartwatches e notebooks no Rio de Janeiro. Com anos de experiência no mercado, 
                nossa missão é devolver a vida aos seus dispositivos com agilidade, eficiência e a garantia 
                de um serviço de excelência.
              </p>
              <p>
                Na Vaz Tech Solutions, entendemos a importância dos seus aparelhos no dia a dia. 
                Atendemos com suporte para produtos das principais marcas do mercado, incluindo 
                <span className="text-white"> Apple, Samsung, Xiaomi e Motorola</span>. Além disso, 
                somos especialistas em <span className="text-white">relógios Garmin</span>, oferecendo 
                um serviço diferenciado.
              </p>
            </div>

            {/* Highlights */}
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {highlights.map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.1 * index }}
                  className="flex items-center gap-3"
                >
                  <CheckCircle size={18} className="text-[#00F0FF] flex-shrink-0" />
                  <span className="text-sm text-[#94A3B8]">{item}</span>
                </motion.div>
              ))}
            </div>

            {/* CTA */}
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}?text=Olá! Gostaria de saber mais sobre os serviços da Vaz Tech Solutions.`}
              target="_blank"
              rel="noopener noreferrer"
              className="cyber-btn inline-block"
              data-testid="about-cta-btn"
            >
              Conheça Nossa Equipe
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
